import { Tooltip } from "@nextui-org/react";
import { CircleAlert } from "lucide-react";
import React from "react";

const InfoToolTip = ({ data, w = "24px", maxWidth = "300px" }) => {
  return (
    <Tooltip
      content={
        <div style={{ maxWidth: maxWidth, wordWrap: "break-word" }}>
          {data}
        </div>
      }
      placement="right"
      className="flex items-center cursor-pointer"
    >
     
      <CircleAlert className={`w-[${w}] h-[${w}] cursor-pointer `} />
    </Tooltip>
  );
};

export default InfoToolTip;
